import { useState } from "react";
import { useContextDashboardBrokerContext } from "src/Contexts/Dashboard/ContextDashboardBroker";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

type IApiResponse = {
  data: { label: string; value: number }[];
  meta: { total: number };
};

const mergeInstallmentsData = (
  allData: IApiResponse,
  primaryData: IApiResponse
) => {
  const map = new Map<string, { valueAll: number; valuePrimary: number }>();

  allData.data.forEach(({ label, value }) => {
    map.set(label, { valueAll: value, valuePrimary: 0 });
  });

  primaryData.data.forEach(({ label, value }) => {
    const existing = map.get(label);
    if (existing) {
      existing.valuePrimary = value;
    } else {
      map.set(label, { valueAll: 0, valuePrimary: value });
    }
  });

  const data = Array.from(map.entries()).map(
    ([label, { valueAll, valuePrimary }]) => ({
      label,
      valueAll,
      valuePrimary,
    })
  );

  return {
    data,
    meta: {
      totalAll: allData.meta.total,
      totalPrimary: primaryData.meta.total,
    },
  };
};

export const UseFormInstallmentsReceived = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const { filterInstallmentsReceived, setDataInstallmentsReceivedCombined } =
    useContextDashboardBrokerContext();

  const [loading, setLoading] = useState(false);

  const handleFormInstallmentsReceived = async () => {
    if (!filterInstallmentsReceived.start_date)
      return handleGetAlert({ message: `Escolha uma data inicial !` });
    if (!filterInstallmentsReceived.end_date)
      return handleGetAlert({ message: `Escolha uma data final !` });

    setLoading(true);

    const endpoint = "/dashboard/corretora/confirmedInstallments";
    const baseFilter = { ...filterInstallmentsReceived };

    return Promise.all([
      api.post(endpoint, { ...baseFilter, numeroParcelas: "ALL" }),
      api.post(endpoint, { ...baseFilter, numeroParcelas: "PRIMARY" }),
    ])
      .then(([resAll, resPrimary]) => {
        const combined = mergeInstallmentsData(resAll.data, resPrimary.data);
        setDataInstallmentsReceivedCombined(combined);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return { handleSubmit: handleFormInstallmentsReceived, loading };
};
